import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { Globals } from 'src/app/globals';
import { EnrollmentAcceptedStudentService } from 'src/app/service/enrollmentAcceptedStudent.service';
import { FileService } from 'src/app/service/file.service';
import { CoursesService } from 'src/app/service/courses.service';


import { environment } from 'src/environments/environment';
import { Console } from 'console';
import { EnrollmentGroupService } from 'src/app/service/enrollment-group.service';
import { AttendanceService } from 'src/app/service/attendance.service';
import { ThisReceiver } from '@angular/compiler';
import { forkJoin, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

// Excel sheet export
import { Cell, Workbook } from 'exceljs';
import * as fs from 'file-saver';
import { decimalDigest } from '@angular/compiler/src/i18n/digest';
import * as XLSX from 'xlsx';
import { ScoresService } from 'src/app/service/scores.service';
declare var $: any;
@Component({
  selector: 'app-re-take-exam',
  templateUrl: './re-take-exam.component.html',
  styleUrls: ['./re-take-exam.component.scss']
})
export class ReTakeExamComponent implements OnInit {


  select: any;
  showLoader: boolean = false;
  loadScoreDetails: boolean = false;
  uploadingFile: boolean = false;
  Searched: boolean = false;
  retakenExamData: any = [];
  retakenExamsOriginal: any = [];
  scoreDetails: any = [];
  scoreDetailsOrginal: any = [];
  currentExamId: any;
  examScoreFile: any;
  examScoreFileName: any;

  years: any;
  semesters: any;
  batches: any;
  orgId: any;
  username: any;

  @ViewChild('closeEditRemarkPopup') private closeEditRemarkPopup: any;

  currentYear: any;
  currentSemester: any;
  currentBatch: any;
  currentStatus: any;
  // currentCourse: any;

  urlSearchYear: any;
  urlSearchSemester: any;
  urlSearchBatch: any;
  urlSearchStatus: any;
  // urlSearchCourse: any;

  table: any;

  excelHeaderName: any;

  photoPath: any = `${environment.API_URL_UTIL}/api/downloadFile/`;

  courses: any = [];
  dateStatus: any = [];
  searchForm = new FormGroup({
    year: new FormControl('', [
      Validators.required,
    ]),
    semester: new FormControl('', [
      Validators.required,
    ]),
    batch: new FormControl('', [
      Validators.required,
    ]),
    course: new FormControl('', [
      // Validators.required,
    ]),
  });

  editRemarkForm = new FormGroup({
    remarks: new FormControl('', [
      Validators.required,
    ]),
  });

  allStudents: any;
  allCourses: any;
  downloadLink: any;
  currentStudentCourseId: any;
  uploadingRemark: any;

  constructor(private toastrService: ToastrService, public enrollmentAcceptedStudentService: EnrollmentAcceptedStudentService, public globals: Globals, private router: Router, public translate: TranslateService, private fileService: FileService, private enrollmentGroupService: EnrollmentGroupService, private coursesService: CoursesService,
    private attendance: AttendanceService, private activatedRoute: ActivatedRoute, private scoresService: ScoresService
  ) { }

  ngOnInit(): void {
    this.downloadLink = environment.API_URL_UTIL + '/api/downloadFile/';
    this.orgId = this.globals.currentUserInfo.orgid;
    this.username = this.globals.currentUserInfo.username;
    this.activatedRoute
      .queryParams
      .subscribe(params => {
        this.currentYear = this.urlSearchYear = params['yearId'] || "";
        this.currentSemester = this.urlSearchSemester = params['semesterId'] || "";
        this.currentBatch = this.urlSearchBatch = params['batchId'] || "";
        // this.currentCourse = this.urlSearchCourse = params['courseId'] || "";

        this.searchForm.controls.year.setValue(this.currentYear);
        this.searchForm.controls.semester.setValue(this.currentSemester);
        this.searchForm.controls.batch.setValue(this.currentBatch);
        // this.searchForm.controls.course.setValue(this.currentCourse);

        this.getYears();
      });

    this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      this.updateTable();
    });
  }

  searchFormChange() {
  }

  searchFormSubmit() {
    // console.log("submit search form");
    if (this.searchForm.valid) {
      this.Searched = true;
      this.currentYear = this.searchForm.controls.year.value;
      this.currentSemester = this.searchForm.controls.semester.value;
      this.currentBatch = this.searchForm.controls.batch.value;
      // this.currentCourse = this.searchForm.controls.course.value.length > 0 ? this.searchForm.controls.course.value : 0;

      this.getFinalExamDataAndCoursesAndAssUnit();

      // console.log("Searching form");
      // console.log(this.searchForm.value);
    } else {
      this.Searched = false;
      this.searchForm.markAllAsTouched();
      this.searchForm.markAsDirty();
    }
  }

  getYears() {
    this.enrollmentGroupService.getYears()
      .subscribe(
        data => {
          this.years = data;
          if (this.urlSearchYear != '') {

            this.getYearSemesters();
          } else {
            this.showLoader = false;
          }
        },
        error => {
          this.toastrService.error(this.translate.instant('CAN_NOT_GET_DATA_BE'));
        }
      );
  }

  getYearSemesters() {
    let year = this.searchForm.controls.year.value;
    if (year) {
      this.enrollmentGroupService.getYearSemesters(year)
        .subscribe(
          data => {
            this.semesters = data;
            if (this.urlSearchSemester != '') {
              this.getBatches();
            }
          },
          error => {
            this.toastrService.error(this.translate.instant('CAN_NOT_GET_DATA_BE'));
          }
        );
    } else {
      this.searchForm.controls.semester.reset();
      this.semesters = [];
    }
  }

  getBatches() {
    let year = this.searchForm.controls.year.value;
    let semester = this.searchForm.controls.semester.value;
    if (year && semester) {
      this.enrollmentGroupService.getSemesterBatches(this.orgId, year, semester)
        .subscribe(
          data => {
            this.batches = data;
            if (this.urlSearchYear != "" && this.urlSearchSemester != "" && this.urlSearchBatch != "") {
              this.Searched = true;
              this.getFinalExamDataAndCoursesAndAssUnit();
            }
          },
          error => {
            this.toastrService.error(this.translate.instant('CAN_NOT_GET_DATA_BE'));
          }
        );
    } else {
      this.searchForm.controls.batch.reset();
      this.batches = [];
    }
  }

  // getBatchCourses() {
  //   let batch = this.searchForm.controls.batch.value;
  //   if (batch) {
  //     this.enrollmentGroupService.getBatchSubjects(this.orgId, batch)
  //       .subscribe(
  //         data => {
  //           this.courses = data;
  //           if (this.urlSearchYear != "" && this.urlSearchSemester != "" && this.urlSearchBatch != "" && this.urlSearchCourse != "") {
  //             this.Searched = true;
  //             this.getFinalExamDataAndCoursesAndAssUnit();
  //           }
  //         },
  //         error => {
  //           this.toastrService.error(this.translate.instant('CAN_NOT_GET_DATA_BE'));
  //         }
  //       );
  //   } else {
  //     this.searchForm.controls.group.reset();
  //     this.courses = [];
  //   }
  // }

  updateTable() {
    // $("#datatable").DataTable().destroy();
    if (this.table) {
      this.table.destroy();
    }
    setTimeout(() => {
      this.table = $("#datatable").DataTable({
        dom: 'Bfrtip',
        pagingType: 'simple_numbers',
        // responsive: true,
        columnDefs: [
          { orderable: true, targets: 0 },
          { orderable: true, targets: 1 },
          { orderable: true, targets: 2 },
          { orderable: true, targets: 3 },
          { orderable: true, targets: 4 },
          { orderable: true, targets: 5 },
          { orderable: true, targets: 7 },
          { orderable: false, targets: '_all' }
        ],
        // "columnDefs": [
        //   { "orderable": false, "targets": [1, 2] }
        // ],
        pageLength: 5,
        lengthChange: false,
        info: true,
        search: {
          searchPlaceholder: "Search",
        },
        paging: true,
        language: {
          search: "",
          searchPlaceholder: "Search",
        },
        buttons: [{
          extend: 'excelHtml5',
          text: '<span style="font-size: 3em; color: green;"><i class="fas fa-file-excel fa-sm"></i></span>',
          titleAttr: 'enarabic',
          exportOptions: {
            columns: [0, 1, 2, 3, 4, 5, 7]
          }
        }],
      });
    }, 1);

  }


  updateCurrentCourseId(id: number, remarks: string = '') {
    console.log("Update current course id");
    this.editRemarkForm.reset();
    this.currentStudentCourseId = id;
    if (remarks) {
      this.editRemarkForm.controls.remarks.setValue(remarks);
    }
  }

  updateCourseStatus(id: number, statusId: number) {
    // Status id => (1-> final, 2 -> cancel)
    let retakenExamObj = this.retakenExamsOriginal.filter((element: any) => element.id == id)[0];
    if (retakenExamObj && statusId == 1) {
      retakenExamObj.retakeStatus = 'FINAL';
      this.updateRetakenExamData(id, retakenExamObj);
    } else if (retakenExamObj && statusId == 2) {
      retakenExamObj.retakeStatus = 'CANCELLED';
      this.updateRetakenExamData(id, retakenExamObj);
    }

  }

  getFinalExamDataAndCoursesAndAssUnit() {
    // Reset URL search params
    this.urlSearchYear = '';
    this.urlSearchSemester = '';
    this.urlSearchBatch = '';
    // this.urlSearchCourse = '';

    this.showLoader = true;
    let bulkApis = [
      this.enrollmentAcceptedStudentService.getAllStudents(),
      this.coursesService.getAllCourses(),
      this.scoresService.getReTakeExamData(this.orgId, this.currentYear, this.currentSemester, this.currentBatch),
    ];

    forkJoin(bulkApis).subscribe(
      data => {
        // console.log(data);
        if (typeof data[0] != undefined)
          this.allStudents = data[0];

        if (typeof data[1] != undefined)
          this.allCourses = data[1];

        if (typeof data[2] != undefined && data[2].length > 0) {
          this.retakenExamData = this.retakenExamsOriginal = data[2];
          this.retakenExamData = this.retakenExamData.map((element: any) => {
            let studentId = element.studentid;
            let subjectid = element.subjectid;
            let student = this.allStudents.filter((i: any) => i.id == studentId)[0];
            let course = this.allCourses.filter((i: any) => i.id == subjectid)[0];
            return { ...element, student, course };
          });
          this.updateTable();
        } else {
          this.retakenExamData = [];
          this.retakenExamsOriginal = [];
          this.toastrService.warning(this.translate.instant("NO_DATA_FOUND"));
        }

        this.showLoader = false;
      },
      error => {
        this.toastrService.error(this.translate.instant("CAN_NOT_GET_DATA_BE"));
        this.showLoader = false;
      }
    );
  }


  updateRetakenExamData(id: any, retakenExamObj: any, updatingRemark: boolean = false) {
    if (updatingRemark) {
      this.uploadingRemark = true;
    } else {
      this.showLoader = true;
    }
    this.scoresService.updateRetakenExamData(this.orgId, id, this.username, retakenExamObj)
      .subscribe(
        data => {
          if (data.sts == "SUCCESS") {
            if (this.globals.lang == "ar") {
              this.toastrService.success(data.arMsg);
            } else {
              this.toastrService.success(data.enMsg);
            }
          } else {
            if (this.globals.lang == "ar") {
              this.toastrService.error(data.arMsg);
            } else {
              this.toastrService.error(data.enMsg);
            }
          }
          this.uploadingRemark = false;
          if (this.closeEditRemarkPopup)
            this.closeEditRemarkPopup.nativeElement.click();
          this.getFinalExamDataAndCoursesAndAssUnit();
        },
        error => {
          this.toastrService.error(this.translate.instant('FAIL_TO_UPDATE'));
          this.uploadingRemark = false;
          this.showLoader = false;
        }
      );
  }

  editRemarkFormSubmit() {
    // console.log("submit upload file form");
    if (this.editRemarkForm.valid) {
      console.log(this.editRemarkForm.value);
      let retakenExamObj = this.retakenExamsOriginal.filter((element: any) => element.id == this.currentStudentCourseId)[0];
      if (retakenExamObj) {
        retakenExamObj.remarks = this.editRemarkForm.controls.remarks.value;
        this.updateRetakenExamData(this.currentStudentCourseId, retakenExamObj, true);
      } else {
        this.closeEditRemarkPopup.nativeElement.click();
      }
      // this.handleUploadFiles();

    } else {
      this.editRemarkForm.markAllAsTouched();
      this.editRemarkForm.markAsDirty();
    }
  }

  editRemarkFormChange() { }
}


